import PlaidLink from '@square/ember-plaid-link/components/plaid-link';
import config from '../config/environment';

const plaidConfig = config['@square/ember-plaid-link'];

export default PlaidLink.extend({
  clientName: null,
  product: null,
  key: null,
  env: null,
  webhook: null,
  token: null,
  countryCodes: null,
  receivedRedirectUri: null,

  init(...args) {
    this._super(...args);

    // If a value is passed in, use that. Otherwise fallback to optional config.
    if (plaidConfig) {
      if (!this.clientName) {
        this.set('clientName', plaidConfig.clientName);
      }

      if (!this.product) {
        this.set('product', plaidConfig.product);
      }

      // `key` is deprecated. Only set it if we don't have a token.
      if (!this.key && !this.token && !plaidConfig.token) {
        this.set('key', plaidConfig.key);
      }

      if (!this.env) {
        this.set('env', plaidConfig.env);
      }

      if (!this.webhook) {
        this.set('webhook', plaidConfig.webhook);
      }

      if (!this.token) {
        this.set('token', plaidConfig.token);
      }

      if (!this.receivedRedirectUri) {
        this.set('receivedRedirectUri', plaidConfig.receivedRedirectUri);
      }

      // If countryCodes param is not supplied by consuming app,
      // empty array means Plaid Link default will be used.
      // See docs: https://plaid.com/docs/#parameter-reference
      if (!this.countryCodes || !this.countryCodes.length) {
        const countryCodes = plaidConfig.countryCodes ? plaidConfig.countryCodes : [];
        this.set('countryCodes', countryCodes);
      }
    }
  }
});
